import { FunctionComponent, h } from 'preact'
import { useEffect, useState } from 'preact/hooks'

import {
  CampaignType,
  FieldEntry,
  GraphQLError,
  Page,
  PARENT_WINDOW_SIZE,
  PublishedEntryMode,
  TriggerEvent,
} from 'scripts/type'
import { getStorageFormSetting, getStorageKey, getUrlParam, postMessage, Storage } from 'scripts/utils'
import SurveyForm from 'components/business/SurveyForm'
import { useReceiveMessages } from 'scripts/hooks'
import BaseContext from 'contexts/base-context'
import SurveyContext from 'contexts/survey-context'
import { queryCampaignFields } from 'scripts/service'
import { ErrorPage } from 'components/ui'
import { WIDGET_WIDTH } from 'scripts/constants'
import { WidgetWidth } from 'components/business/Preview/type'

export type Props = {
  token: string
  isUrlVisit?: boolean
}

const Survey: FunctionComponent<Props> = (props) => {
  const { token } = props
  const { parentWindowSize } = useReceiveMessages(token)
  const [error, setError] = useState<GraphQLError>()
  const [pages, setPages] = useState<Page[]>([])
  const [activePageIndex, setActivePageIndex] = useState<number>(0)
  const [lastSubmitFieldCode, setLastSubmitFieldCode] = useState<string>()
  const width = (getUrlParam('width') || WidgetWidth.XLARGE) as WidgetWidth
  Storage.setItem(getStorageKey('urlPublishedFormToken', token), token)

  useEffect(() => {
    postMessage({ name: TriggerEvent.Loaded, data: { campaignToken: token } })
  }, [])
  useEffect(() => {
    postMessage({ name: TriggerEvent.FieldChange, data: { campaignToken: token } })
  }, [activePageIndex])

  useEffect(() => {
    const mode = getUrlParam('mode') === 'preview' ? PublishedEntryMode.PREVIEW : undefined
    queryCampaignFields({
      campaignToken: token,
      mode,
      type: CampaignType.SURVEY,
      isUrlVisit: props.isUrlVisit,
    })
      .then((page) => {
        setPages([page])
      })
      .catch((e) => {
        console.error(e)
        setError(e[0])
      })
  }, [token])

  const handleChange = (page: Page) => {
    setPages([...pages, page])
  }

  const handlePageComplete = (entryId: string, fieldsEntry: FieldEntry[]) => {
    postMessage({ name: TriggerEvent.PageComplete, data: { campaignToken: token, entryId, fieldsEntry } })
  }

  if (error) {
    return <ErrorPage error={error} campaignType={CampaignType.SURVEY} />
  }

  return (
    <BaseContext.Provider
      value={{
        parentWindowSize,
        interactive: true,
        isPreview: false,
        isUrlVisit: props.isUrlVisit,
        urlToken: token,
        formSetting: getStorageFormSetting(token),
        width,
      }}
    >
      <SurveyContext.Provider
        value={{
          pages: pages!,
          activePageIndex,
          setActivePageIndex,
          lastSubmitFieldCode,
          setLastSubmitFieldCode,
          wrapperMaxWidth:
            parentWindowSize === PARENT_WINDOW_SIZE.SM
              ? window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
              : WIDGET_WIDTH[width],
        }}
      >
        {pages.length ? (
          <SurveyForm pages={pages} onFieldChange={handleChange} onPageComplete={handlePageComplete} />
        ) : null}
      </SurveyContext.Provider>
    </BaseContext.Provider>
  )
}

export default Survey
